import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CreateInquiryModal = ({ onClose, onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    positionRequired: 'striker',
    budgetMin: '',
    budgetMax: '',
    timelineDeadline: '',
    playerSpecifications: {}
  });

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg shadow-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <h2 className="text-2xl font-bold text-foreground">Post Transfer Inquiry</h2>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <Icon name="X" size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Inquiry Title *</label>
            <Input
              name="title"
              value={formData?.title}
              onChange={handleChange}
              placeholder="e.g., Seeking Elite Striker for Champions League Campaign"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Description *</label>
            <textarea
              name="description"
              value={formData?.description}
              onChange={handleChange}
              placeholder="Provide detailed requirements and expectations..."
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              rows={4}
              required
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Position Required *</label>
              <Select
                value={formData?.positionRequired}
                onChange={(value) => handleSelectChange('positionRequired', value)}
                options={[
                  { value: 'goalkeeper', label: 'Goalkeeper' },
                  { value: 'right-back', label: 'Right Back' },
                  { value: 'left-back', label: 'Left Back' },
                  { value: 'center-back', label: 'Center Back' },
                  { value: 'defensive-midfielder', label: 'Defensive Midfielder' },
                  { value: 'central-midfielder', label: 'Central Midfielder' },
                  { value: 'attacking-midfielder', label: 'Attacking Midfielder' },
                  { value: 'right-winger', label: 'Right Winger' },
                  { value: 'left-winger', label: 'Left Winger' },
                  { value: 'striker', label: 'Striker' },
                  { value: 'center-forward', label: 'Center Forward' }
                ]}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Timeline Deadline</label>
              <Input
                type="date"
                name="timelineDeadline"
                value={formData?.timelineDeadline}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Budget Min (€M)</label>
              <Input
                type="number"
                name="budgetMin"
                value={formData?.budgetMin}
                onChange={handleChange}
                placeholder="e.g., 40"
                step="0.1"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Budget Max (€M)</label>
              <Input
                type="number"
                name="budgetMax"
                value={formData?.budgetMax}
                onChange={handleChange}
                placeholder="e.g., 80"
                step="0.1"
              />
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" onClick={onClose} fullWidth>
              Cancel
            </Button>
            <Button type="submit" variant="default" fullWidth disabled={loading}>
              {loading ? 'Posting...' : 'Post Inquiry'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateInquiryModal;